const LOGOS = [
  {
    name: "VECTOR_SYS",
    icon: (
      <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" />
    ),
  },
  {
    name: "SYNAPSE_AI",
    icon: <circle cx="12" cy="12" r="9" />,
  },
  {
    name: "CORE_KERNEL",
    icon: <rect x="4" y="4" width="16" height="16" rx="2" />,
  },
  {
    name: "APEX_LOFT",
    icon: <polygon points="12,2 22,22 2,22" />,
  },
  {
    name: "DATA_THREAD",
    icon: (
      <path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z" />
    ),
  },
];

const LogoRow = () => (
  <div className="flex shrink-0 items-center gap-12">
    {LOGOS.map((logo) => (
      <span key={logo.name} className="flex items-center gap-2" data-testid={`client-logo-${logo.name.toLowerCase()}`}>
        <svg className="h-4 w-4" viewBox="0 0 24 24" fill="currentColor">
          {logo.icon}
        </svg>
        {logo.name}
      </span>
    ))}
  </div>
);

export const LogoMarquee = () => {
  return (
    <section
      data-testid="client-logos-section"
      className="overflow-hidden border-b border-[#1e293b]/40 bg-[#070a0e] py-12"
    >
      <div className="mx-auto mb-4 max-w-6xl px-6">
        <p className="font-mono text-xs uppercase tracking-widest text-[#64748b]">
          Empowering developers at teams worldwide
        </p>
      </div>
      <div className="rl-mq-track gap-12 font-mono text-sm font-bold text-[#64748b]">
        <LogoRow />
        <LogoRow />
      </div>
    </section>
  );
};
